// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "DatePickerLazy" + "." + "c569d60b" + ".css";
};